import session from '@/shared/session'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
	eventOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/events/event/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	eventDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/events/event/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				console.log(response)
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	eventCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/events/event/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	eventUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/events/event/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	eventRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/events/event/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterevent ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/events/event/${data.id}/`, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    eventStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/events/event/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
